import { sendEmailVerification as fbSendEmailVerification, User } from 'firebase/auth';

/**
 * Sends a verification email to the user
 * 
 * @param user The Firebase User object
 * @returns A promise that resolves when the email is sent
 */
export const sendEmailVerification = (user: User) => {
  return fbSendEmailVerification(user);
}; 